export const SHOP_SALE_FIXED = 'fixed';
export const SHOP_SALE_VARIABLE = 'variable';

export type ShopSaleOffer = typeof SHOP_SALE_FIXED | typeof SHOP_SALE_VARIABLE;

export type ShopSaleDish = {
  availableInFixedOffer?: boolean | null;
  availableInVariableOffer?: boolean | null;
};

export const SHOP_SALE_OFFERS: {
  value: ShopSaleOffer;
  translationKey: string;
}[] = [
  { value: SHOP_SALE_FIXED, translationKey: 'form.field.shopSale.fixedOffer' },
  {
    value: SHOP_SALE_VARIABLE,
    translationKey: 'form.field.shopSale.variableOffer',
  },
];

export const isAvailableInOffer = (
  dish: ShopSaleDish,
  offer: ShopSaleOffer
): boolean =>
  offer === SHOP_SALE_FIXED
    ? dish?.availableInFixedOffer === true
    : dish?.availableInVariableOffer !== false;

export const getShopSaleLabels = (
  dish: ShopSaleDish,
  translate: (key: string) => string
): string =>
  SHOP_SALE_OFFERS.filter(({ value }) => isAvailableInOffer(dish, value))
    .map(({ translationKey }) => translate(translationKey))
    .join(', ');
